import api from "~/api/api.js";

// Always talks to the single central API (same apiDomain every poddomain
// frontend already points at) — that's what makes the cart "sквозная".
export class Cart {

    static get(): Promise<any> {
        return api("/cart");
    }

    static add(item: {
        product_id: number;
        item_id?: number | null;
        vibe_id?: number | null;
        attribute_label?: string | null;
        attribute_value?: string | null;
        name: string;
        price: number;
        quantity?: number;
        source_domain?: string;
        partner_code?: string | null;
    }): Promise<any> {
        const fd = new FormData();
        fd.append("product_id", String(item.product_id));
        if (item.item_id) fd.append("item_id", String(item.item_id));
        if (item.vibe_id) fd.append("vibe_id", String(item.vibe_id));
        if (item.attribute_label) fd.append("attribute_label", item.attribute_label);
        if (item.attribute_value) fd.append("attribute_value", item.attribute_value);
        fd.append("name", item.name);
        fd.append("price", String(item.price));
        fd.append("quantity", String(item.quantity ?? 1));
        fd.append("source_domain", item.source_domain ?? "");
        if (item.partner_code) fd.append("partner_code", item.partner_code);
        return api("/cart/add", fd, "POST");
    }

    static remove(id: number): Promise<any> {
        return api(`/cart/remove/${id}`, null, "DELETE");
    }

    /** Установить/сменить промокод корзины. Возвращает { partner } при успехе. */
    static promo(code: string): Promise<any> {
        const fd = new FormData();
        fd.append("code", code);
        return api("/cart/promo", fd, "POST");
    }

    static removePromo(): Promise<any> {
        return api("/cart/promo", null, "DELETE");
    }

    static merge(items: Array<{
        product_id: number;
        item_id?: number | null;
        vibe_id?: number | null;
        attribute_label?: string | null;
        attribute_value?: string | null;
        name: string;
        price: number;
        quantity: number;
        source_domain?: string;
    }>, partnerCode?: string | null): Promise<any> {
        const fd = new FormData();
        items.forEach((item, i) => {
            fd.append(`items[${i}][product_id]`, String(item.product_id));
            if (item.item_id) fd.append(`items[${i}][item_id]`, String(item.item_id));
            if (item.vibe_id) fd.append(`items[${i}][vibe_id]`, String(item.vibe_id));
            if (item.attribute_label) fd.append(`items[${i}][attribute_label]`, item.attribute_label);
            if (item.attribute_value) fd.append(`items[${i}][attribute_value]`, item.attribute_value);
            fd.append(`items[${i}][name]`, item.name);
            fd.append(`items[${i}][price]`, String(item.price));
            fd.append(`items[${i}][quantity]`, String(item.quantity));
            fd.append(`items[${i}][source_domain]`, item.source_domain ?? "");
        });
        if (partnerCode) fd.append("partner_code", partnerCode);
        return api("/cart/merge", fd, "POST");
    }

}
